import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import {
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexStroke,
  ApexDataLabels,
  ApexPlotOptions,
  ApexTooltip,
  ApexTitleSubtitle,
} from 'ng-apexcharts';
import { apiEndPoints } from '../../api/apiEndPoint';
import { DashboardService } from '../../Services/dashboard.service';
import { MasterInformationService } from '../../Services/master-information.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  colors: string[];
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
};

@Component({
  selector: 'app-baldia-overall-dashboard',
  standalone: true,
  imports: [
    NgApexchartsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ToastrModule,
  ],
  templateUrl: './baldia-overall-dashboard.component.html',
  styleUrls: ['./baldia-overall-dashboard.component.css'],
})
export class BaldiaOverallDashboardComponent implements OnInit {
  @ViewChild('chart') chart!: ChartComponent;
  selectedCityId: any;
  zoneList: any;
  cityList: any;
  selectedZoneId: any;
  zoneListIndividual: any;
  zoneListCorporate: any;
  zoneListDumpster: any;
  zoneListDumpyard: any;
  getFilterCount: any = {
    onBusinessIndividualRequestorCount: 0,
    offBusinessIndividualRequestorCount: 0,
    registeredIndividualRequestorCount: 0,
  };
  allCount: any;

  constructor(
    private renderer: Renderer2,
    private dashService: DashboardService,
    private masterService: MasterInformationService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getCity();
    this.getInitialDashboardDetails();
    this.getAllCount();
  }

  // ------------------------------ Individual ChartOptions ------------------------------ //

  public individualChartOptions: ChartOptions = {
    series: [
      {
        name: 'On Business Individual Requestor',
        data: [
          this.getFilterCount.onBusinessIndividualRequestorCount,
          this.getFilterCount.offBusinessIndividualRequestorCount,
          this.getFilterCount.registeredIndividualRequestorCount,
        ],
      },
    ],
    chart: { type: 'bar', height: 200, toolbar: { show: false } },
    xaxis: {
      categories: [
        'On Business',
        'Off Business',
        'Registered Users',
      ],
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: { colors: ['#fff'] },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: { position: 'bottom' },
      },
    },
    yaxis: { labels: { show: false } },
    tooltip: {
      theme: 'dark',
      x: { show: false },
      y: { title: { formatter: () => '' } },
    },
    colors: ['#12436d', '#801650', '#28a197'],
    title: {},
    subtitle: {},
  };

  // ------------------------------ Corporate ChartOptions ------------------------------ //

  public corporateChartOptions: ChartOptions = {
    series: [{ name: 'Corporate Users', data: [500, 700, 900] }],
    chart: { type: 'bar', height: 200, toolbar: { show: false } },
    xaxis: {
      categories: [
        'On Business',
        'Off Business',
        'Registered Users',
      ],
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: { colors: ['#fff'] },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: { position: 'bottom' },
      },
    },
    yaxis: { labels: { show: false } },
    tooltip: {
      theme: 'dark',
      x: { show: false },
      y: { title: { formatter: () => '' } },
    },
    colors: ['#12436d', '#801650', '#28a197'],
    title: {},
    subtitle: {},
  };

  // ------------------------------ Dumpster ChartOptions ------------------------------ //

  public dumpsterChartOptions: ChartOptions = {
    series: [{ name: 'Dumpster Users', data: [500, 700, 900] }],
    chart: { type: 'bar', height: 230, toolbar: { show: false } },
    xaxis: {
      categories: [
        'On Business',
        'Off Business',
        'Registered Users',
      ],
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: { colors: ['#fff'] },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: { position: 'bottom' },
      },
    },
    yaxis: { labels: { show: false } },
    tooltip: {
      theme: 'dark',
      x: { show: false },
      y: { title: { formatter: () => '' } },
    },
    colors: ['#12436d', '#801650', '#28a197'],
    title: {},
    subtitle: {},
  };

  // ------------------------------ Dumpyard ChartOptions ------------------------------ //

  public dumpyardChartOptions: ChartOptions = {
    series: [{ name: 'Dumpyard Users', data: [500, 700, 500] }],
    chart: { type: 'bar', height: 230, toolbar: { show: false } },
    xaxis: {
      categories: [
        'On Business',
        'Off Business',
        'Registered Users',
      ],
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: { colors: ['#fff'] },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: { position: 'bottom' },
      },
    },
    yaxis: { labels: { show: false } },
    tooltip: {
      theme: 'dark',
      x: { show: false },
      y: { title: { formatter: () => '' } },
    },
    colors: ['#12436d', '#801650', '#28a197'],
    title: {},
    subtitle: {},
  };

  // ------------------------------ City List API ------------------------------ //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        console.log('Success --->', response);
        this.cityList = response.body.details;
      },
      error: (error) => {
        console.error('API Error:', error);
        console.error('Error Status:', error.status);
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event, userType: any) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.getDashboardDetails(userType);
    this.getZone(userType);
  }

  // ----------------------------------- Get Zone List API ----------------------------------- //

  getZone(userType: any) {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;

          if (userType === 1) {
            this.zoneListIndividual = this.zoneList;
          } else if (userType === 2) {
            this.zoneListCorporate = this.zoneList;
          } else if (userType === 3) {
            this.zoneListDumpster = this.zoneList;
          } else if (userType === 4) {
            this.zoneListDumpyard = this.zoneList;
          }
        },
        error: (error) => {
          // this.toastr.error(
          //   'An unexpected error occurred zoneeeeeeeeee. Please try again later.',
          //   'Error',
          //   {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //     progressBar: true,
          //   }
          // );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event, userType: any) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.getDashboardDetails(userType);
  }

  // ----------------------------------- Initial Dashboard API ----------------------------------- //

  getInitialDashboardDetails() {
    this.dashService
      .getBaldiaDashboard(apiEndPoints.baldiaUserDashboard)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.getFilterCount = response.body.details;
            console.log(this.getFilterCount);
            this.individualChartOptions.series = [
              {
                name: 'On Business Individual Requestor',
                data: [
                  this.getFilterCount.onBusinessIndividualRequestorCount,
                  this.getFilterCount.offBusinessIndividualRequestorCount,
                  this.getFilterCount.registeredIndividualRequestorCount,
                ],
              },
            ];
            this.corporateChartOptions.series = [
              {
                name: 'Corporate Users',
                data: [
                  this.getFilterCount.onBusinessCorporateRequestorCount,
                  this.getFilterCount.offBusinessCorporateRequestorCount,
                  this.getFilterCount.registeredCorporateRequestorCount,
                ],
              },
            ];
            this.dumpsterChartOptions.series = [
              {
                name: 'Dumpster Users',
                data: [
                  this.getFilterCount.onBusinessDumpsterCount,
                  this.getFilterCount.offBusinessDumpsterCount,
                  this.getFilterCount.registeredDumpsterCount,
                ],
              },
            ];
            this.dumpyardChartOptions.series = [
              {
                name: 'Dumpyard Users',
                data: [
                  this.getFilterCount.onBusinessDumpyardCount,
                  this.getFilterCount.offBusinessDumpyardCount,
                  this.getFilterCount.registeredDumpyardCount,
                ],
              },
            ];
          }
        },
      });
  }

  // ----------------------------------- Dashboard API ----------------------------------- //

  getDashboardDetails(userType: any) {
    this.dashService
      .getBaldiaDashboard(
        apiEndPoints.baldiaUserDashboard,
        this.selectedCityId,
        this.selectedZoneId
      )
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.getFilterCount = response.body.details;
            console.log(this.getFilterCount);
            if (userType == 1) {
              this.individualChartOptions.series = [
                {
                  name: 'On Business Individual Requestor',
                  data: [
                    this.getFilterCount.onBusinessIndividualRequestorCount,
                    this.getFilterCount.offBusinessIndividualRequestorCount,
                    this.getFilterCount.registeredIndividualRequestorCount,
                  ],
                },
              ];
            } else if (userType == 2) {
              this.corporateChartOptions.series = [
                {
                  name: 'Corporate Users',
                  data: [
                    this.getFilterCount.onBusinessCorporateRequestorCount,
                    this.getFilterCount.offBusinessCorporateRequestorCount,
                    this.getFilterCount.registeredCorporateRequestorCount,
                  ],
                },
              ];
            } else if (userType == 3) {
              this.dumpsterChartOptions.series = [
                {
                  name: 'Dumpster Users',
                  data: [
                    this.getFilterCount.onBusinessDumpsterCount,
                    this.getFilterCount.offBusinessDumpsterCount,
                    this.getFilterCount.registeredDumpsterCount,
                  ],
                },
              ];
            } else if (userType == 4) {
              this.dumpyardChartOptions.series = [
                {
                  name: 'Dumpyard Users',
                  data: [
                    this.getFilterCount.onBusinessDumpyardCount,
                    this.getFilterCount.offBusinessDumpyardCount,
                    this.getFilterCount.registeredDumpyardCount,
                  ],
                },
              ];
            }
          }
        },
      });
  }

  // ----------------------------------- Card Count Dashboard API ----------------------------------- //

  getAllCount() {
    this.dashService
      .getDashboardList(apiEndPoints.getDashboardDetails)
      .subscribe({
        next: (response: any) => {
          this.allCount = response.body.details;
          console.log(this.allCount)
        },
      });
  }
}
